import { defaultTheme } from 'evergreen-ui'
import { merge } from 'lodash'

const DarkContentDashTheme = merge({}, defaultTheme, {
  ...defaultTheme,
    components: {
      ...defaultTheme.components,
      Text:{
        baseStyles: {
          color: "white"
        }
      },
      Button: {
        ...defaultTheme.components.Button,
        appearances: {
          primary: {
            color: 'white',
            paddingX: 12,
            paddingY: 8,
            borderRadius: 5,
            backgroundColor: '#FF9900',
            _hover: {
              backgroundColor: 'orange',
            },
            _active: {
              backgroundColor: '#FF9900',
            },
            _focus: {
              boxShadow: '0 0 0 2px #ffe6c1',
            },
            _disabled: {
              backgroundColor: 'white',
              borderColor: '#c1c4d6',
              color: '#696f8c',
            },
          },
          orange: {
            color: 'white',
            paddingX: 12,
            paddingY: 8,
            borderRadius: 5,
            backgroundColor: '#FF9900',
            _hover: {
              backgroundColor: 'orange',
              boxShadow: '0 0 0 1px #ffe6c1',
            },
            _active: {
              backgroundColor: '#FF9900',
              borderColor: 'none',
            },
            _focus: {
              boxShadow: 'none',
            },
            _disabled: {
              backgroundColor: 'white',
              borderColor: '#c1c4d6',
              color: '#696f8c',
            },
          },
          light: {
            border: "none",
            paddingX: 12,
            paddingY: 8,
            borderRadius: 5,
            backgroundColor: 'transparent',
            _hover: {
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              boxShadow: '0 0 0 1px #ffe6c1',
            },
            _active: {
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              color: '#FF9900',
            },
            _focus: {
              boxShadow: 'none',
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              color: '#FF9900',
            },
            _disabled: {
              backgroundColor: 'white',
              borderColor: '#c1c4d6',
              color: '#696f8c',
            },
          },
          selectedlight: {
            border: "none",
            paddingX: 12,
            paddingY: 8,
            borderRadius: 5,
            backgroundColor: '#FDF4E7',
            borderColor: '#FF9900',
            color: '#FF9900',
            _hover: {
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              boxShadow: '0 0 0 1px #ffe6c1',
            },
            _active: {
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              color: '#FF9900',
            },
            _focus: {
              boxShadow: 'none',
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              color: '#FF9900',
            },
            _disabled: {
              backgroundColor: 'white',
              borderColor: '#c1c4d6',
              color: '#696f8c',
            },
          },
          selected: {
            borderColor: '#C2C4D4',
            paddingX: 12,
            paddingY: 8,
            borderRadius: 5,
            backgroundColor: 'transparent',
            _hover: {
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              boxShadow: '0 0 0 1px #ffe6c1',
            },
            _active: {
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              color: '#FF9900',
            },
            _focus: {
              boxShadow: 'none',
              backgroundColor: '#FDF4E7',
              borderColor: '#FF9900',
              color: '#FF9900',
            },
            _disabled: {
              backgroundColor: 'white',
              borderColor: '#c1c4d6',
              color: '#696f8c',
            },
          },
          minimal: {
            ...defaultTheme.components.Button.appearances,
            _focus: {
              boxShadow: 'none',
            },
          }
        },
      },
      Radio: {
        appearances: {
          default: {
            _checked: {
              background: "colors.orange500"
            },
            _checkedActive: {
              background: "colors.orange500"
            },
            _checkedHover: {
              background: 'colors.orange500',
              boxShadow: '0 0 0 2px #ffe6c1',
            },
            _hover: {
              background: 'colors.orange500',
              boxShadow: '0 0 0 2px #ffe6c1',
            },
            _active: {
              background: 'colors.orange300',
              boxShadow: '0 0 0 2px #ffe6c1',
            },
            _focus: {
              boxShadow: '0 0 0 2px #FF9900',
            },
          },
          primary: {
            color: 'white',
            paddingX: 12,
            paddingY: 8,
            borderRadius: 5,
            backgroundColor: '#FF9900',
            _hover: {
              backgroundColor: '#FF9900',
            },
            _active: {
              backgroundColor: '#FF9900',
            },
            _focus: {
              boxShadow: '0 0 0 2px #FF9900',
            },
          }
        },
      }
    },
});
export default DarkContentDashTheme
